<template>
    <div class="text-center">
        <h3 class="mm-color mb-3">Die neuen Preise ab 01.04.2020</h3>
        <img src="../../assets/Preise_ab_01.04.20.jpg" alt="Neue Preise">
    </div>
</template>

<script>
    export default {
        
    }
</script>

<style scoped>
img{
    max-width: 100%;
}
</style>